import { cn } from "../../lib/cn.js";

export function Card({ className, children, ...props }) {
  return (
    <div
      className={cn("rounded-xl border border-border-subtle bg-bg-elevated shadow-card", className)}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardHeader({ className, children, ...props }) {
  return (
    <div
      className={cn(
        "flex items-center justify-between border-b border-border-subtle px-6 py-4",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

export function CardTitle({ className, children, ...props }) {
  return (
    <h3
      className={cn("font-display text-base font-semibold text-text-primary", className)}
      {...props}
    >
      {children}
    </h3>
  );
}

export function CardBody({ className, children, ...props }) {
  return (
    <div className={cn("px-6 py-5", className)} {...props}>
      {children}
    </div>
  );
}

export function CardFooter({ className, children, ...props }) {
  return (
    <div className={cn("border-t border-border-subtle px-6 py-4", className)} {...props}>
      {children}
    </div>
  );
}
